// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"468144ba","453":"8b33be91","551":"4bdfd54b"}[chunkId] + ".chunk.js";
};